import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../redux-store';
import {
  selectActiveClient,
  selectActiveClientId,
  selectActiveClientTitle,
  selectActiveClientViews,
  selectActiveClientBrand,
  selectActiveClientCompany,
  selectIsClientActive,
} from './active-client.selectors';
import { setActiveClient, clearActiveClient } from './active-client.slice';
import { Client } from 'src/pages/client-management/types/client.types';

export const useActiveClient = () => {
  const dispatch = useDispatch();

  const activeClient = useSelector(selectActiveClient);
  const activeClientId = useSelector(selectActiveClientId);
  const activeClientTitle = useSelector(selectActiveClientTitle);
  const activeClientViews = useSelector(selectActiveClientViews);
  const activeClientBrand = useSelector(selectActiveClientBrand);
  const activeClientCompany = useSelector(selectActiveClientCompany);
  const isClientActive = useSelector(selectIsClientActive);
  const isLoading = useSelector((state: RootState) => state.activeClient.isLoading);
  const error = useSelector((state: RootState) => state.activeClient.error);

  const setClient = (client: Client | null) => {
    client?.companies.map(company => company);
    dispatch(setActiveClient(client));
  };

  const clearClient = () => {
    dispatch(clearActiveClient());
  };

  return {
    // Data
    activeClient,
    activeClientId,
    activeClientTitle,
    activeClientViews,
    activeClientBrand,
    activeClientCompany,
    isClientActive,
    isLoading,
    error,

    // Actions
    setClient,
    clearClient,
  };
};
